import { useEffect, useState } from "react"
import Link from "next/link"
import PropTypes from "prop-types"

const MobileNavItem = ({
  navItem,
  classNames,
  linkClass,
  svgElement,
  secondaryNavItemFuncMobile,
  handleCloseHandle,
  navItemLabel = "",
}) => {
  const [cookieClass, setCookieClass] = useState("")

  useEffect(() => {
    if (navItem?.fields?.label === "Cookies Settings") {
      setCookieClass("ot-sdk-show-settings")
    }
  }, [])

  const hasSecondaryNav =
    Array.isArray(navItem?.fields?.secondaryNavigation) &&
    navItem.fields.secondaryNavigation.length > 0

  return (
    <div
      key={navItem?.sys?.id}
      className={classNames}
      onClick={e => secondaryNavItemFuncMobile(e, navItem)}
    >
      {navItem?.fields?.url && !hasSecondaryNav ? (
        <Link passHref href={navItem?.fields?.url || ""} legacyBehavior>
          <a
            key={navItem?.fields?.sys?.id}
            target={navItem?.fields?.openerType === "New Tab" ? "_blank" : ""}
            id={
              navItem?.fields?.label === "Cookies Settings" ? "ot-sdk-link" : ""
            }
            className={cookieClass}
            style={{ textDecoration: "none", width: "100%" }}
            rel="noreferrer"
            onClick={() => handleCloseHandle()}
          >
            <div className={linkClass}>
              {navItem?.fields?.label ? (
                <>
                  <span>{navItem?.fields?.label}</span>
                  <span>{svgElement}</span>
                </>
              ) : null}
            </div>
          </a>
        </Link>
      ) : (
        <button
          key={navItem?.fields?.sys?.id}
          id={
            navItem?.fields?.label === "Cookies Settings" ? "ot-sdk-link" : ""
          }
          className={cookieClass}
          style={{
            textDecoration: "none",
            width: "stretch",
            textAlign: "left",
          }}
          onClick={handleCloseHandle}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              handleCloseHandle(e)
            }
          }}
        >
          <div className={linkClass}>
            {navItem?.fields?.label || navItemLabel ? (
              <>
                <span>{navItem?.fields?.label || navItemLabel}</span>
                <span>{svgElement}</span>
              </>
            ) : null}
          </div>
        </button>
      )}
    </div>
  )
}
export default MobileNavItem

MobileNavItem.propTypes = {
  navItem: PropTypes.object,
  secondaryNavItemFuncMobile: PropTypes.func,
  svgElement: PropTypes.element,
  linkClass: PropTypes.string,
  classNames: PropTypes.string,
  handleCloseHandle: PropTypes.func,
}

MobileNavItem.defaultProps = {
  secondaryNavItemFuncMobile: () => {},
  navItem: {},
  classNames: "",
  linkClass: "",
  svgElement: <></>,
  handleCloseHandle: () => {},
}
